import { CIMSColumn } from 'components/CIMSTable/CIMSColumn/types'
import { PhotoFilename } from '../../PhotoFilenameContext/types'
import { HelpMessage } from '../../../../../../../../../../../utils/constants'
import Example from './components/Example'
import Template from './components/Template'

export function useColumns(): CIMSColumn<PhotoFilename>[] {
  const help = HelpMessage.Exports
  return [
    {
      title: 'Record Type',
      render: 'classTypeName',
      help: help.Name('photo'),
      width: 268,
      sort: { with: 'key', key: 'classTypeName', default: 'ascend' },
    },
    {
      title: 'Example',
      render: (record) => <Example {...record} />,
      help: help.Example,
      width: 500,
    },
    {
      title: 'Template',
      help: help.Template('photo'),
      render: (record) => <Template {...record} />,
      width: 500,
    },
  ]
}
